import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { BaseUiModule } from '@mitsubishi/shared/ui';
import { UiTableModule } from '@mitsubishi/ui/table';

import { LetDirective } from '@ngrx/component';

import { StudyModelsComponent } from './study-models.component';

@NgModule({
  declarations: [StudyModelsComponent],
  imports: [CommonModule, BaseUiModule, UiTableModule, LetDirective],
  exports: [StudyModelsComponent],
})
export class StudyModelsModule {}
